import { PhotoIndexInfo } from "../interfaces/PhotoIndexInfo.interface";

export class ChangeOutsideSurveyPhotoIndexDTO {
  id: string;
  photosIndexInfo: PhotoIndexInfo[];

  constructor(dto: Partial<ChangeOutsideSurveyPhotoIndexDTO>) {
    Object.assign(this, dto);
  }
}
